import { createFormData } from "./../../../../infra/helpers/createFormData";
import { useMutation } from "react-query";
import { httpUploads } from "infra/http";
import { DocumentoForm, UseSaveDocumentosProps } from "../typings";

function useSaveArquivo({ id }: UseSaveDocumentosProps) {
  return useMutation(
    (data: DocumentoForm) => {
      const formData = createFormData(data.file, data, "file");
      if (id) {
        return httpUploads.put(`/v1/documento/${id}`, formData);
      }

      return httpUploads.post(`/v1/documento`, formData);
    },
    { retry: false }
  );
}

export default useSaveArquivo;
